module.exports = __webpack_public_path__ + "img/template_placeholder_purple.7f1e03c.png";